/* eslint-disable @typescript-eslint/ban-ts-comment */
/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：CSVファイル処理を提供するサービス
 *
 * 作成者：2022/1/12 ノア）黄
 * 最終修正者：2022/1/12 ノア）黄
 *
 */
import { localService } from '@/commons/services/localService'
import jqCsv from 'jquery-csv'

/**
 * 共有メソッドを提供するサービス
 *
 * @class
 */
class CSVService {
  /**
   * CSVファイルをパースする
   *
   * @param {Blob} file ファイル
   * @param {string[]} headers CSVヘッダーリスト
   * @param {any} callback ファイルのパース結果を受け取るコールバック
   * @param {any} errorCallback エラー発生する時のコールバック
   * @returns {void}
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async parseCsv(file: Blob, headers: string[], callback: any, errorCallback: any): Promise<void> {
    if (!file) {
      return
    }

    const reader = new FileReader()

    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        if (e && e.target) {
          const text = e.target.result as string
          const result = this.csvToJSON(text, headers)
          callback(result)
        }
      } catch (e) {
        errorCallback()
      }
    }

    reader.onerror = () => {
      errorCallback()
    }

    reader.readAsText(file, 'MS932')
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  csvToJSON(csv: string, headers: string[]): any[] {
    const csvData = csv.replace(/\r\n/g, '\n')
    const lines = csvData.split('\n')
    if (localService.itpConnectValidFlag === '1') {
      if (!lines[0].includes('利用可能都道府県')) {
        headers = headers.filter(header => header !== 'prefecture')
      }
    }
    const result = []

    for (let i = 0; i < lines.length; i++) {
      const obj = {}
      const currentline = jqCsv.toArray(lines[i])

      if (!currentline.toString() && i === lines.length - 1) {
        continue
      }

      for (let j = 0; j < headers.length; j++) {
        // @ts-ignore
        obj[headers[j]] = currentline[j]
      }

      result.push(obj)
    }

    return result
  }
}

// export as singleton
export default new CSVService()
